import React from 'react';
import './promoHeader.css';
import { useDispatch } from "react-redux";
import { photoFileAction, promoFormAction } from "../../../redux/rootReducer";
import { PROMO_FORM_INITIAL } from "../../../redux/initialStateConstant";

const PromoHeader = () => {
    const dispatch = useDispatch();

    return (
        <>
            <div className="button button--add"
                onClick={ () => {
                    dispatch(promoFormAction({
                        ...PROMO_FORM_INITIAL,
                        open: true
                    }));
                    dispatch(photoFileAction(null));
                } }
            >Добавить акцию</div>
        </>
    );
};

export default PromoHeader;